

export class AplosApiReponseDiagnostics {

    public startTime?: string;
    public endTime?: string;
    public duration?: string;

}

export abstract class AplosApiDiagnosticResponse<TData> {

    public data?: TData;
    public timestamp?: string;
    public statusCode?: number;
    public success?: boolean;
    public diagnostics?: AplosApiReponseDiagnostics; 

}


export const isAplosApiDiagnosticResponse = (obj: any): obj is AplosApiDiagnosticResponse<any> => {
  if (!obj || typeof obj !== 'object') return false
  const hasData = Object.prototype.hasOwnProperty.call(obj, 'data')
  const hasEnvelopeProp = ['timestamp', 'statusCode', 'success', 'diagnostics']
    .some(p => Object.prototype.hasOwnProperty.call(obj, p))
  return hasData && hasEnvelopeProp
}